import { FilterPreset } from "../../models/filter-models";
import {
  presetEarlyCampaign1,
  presetMidCampaign30,
  presetLateCampaignEarlyMaps60,
  presetMidMaps70,
  presetEndGame80,
  presetStrict90,
  presetVeryStrict95,
} from "./filter-presets";

// Ruthless mode does not exist in PoE2; re-export regular presets as no-op.
export const ruthlessPresetEarlyCampaign1: FilterPreset = presetEarlyCampaign1;
export const ruthlessPresetMidCampaign30: FilterPreset = presetMidCampaign30;
export const ruthlessPresetLateCampaignEarlyMaps60: FilterPreset = presetLateCampaignEarlyMaps60;
export const ruthlessPresetMidMaps70: FilterPreset = presetMidMaps70;
export const ruthlessPresetEndGame80: FilterPreset = presetEndGame80;
export const ruthlessPresetStrict90: FilterPreset = presetStrict90;
export const ruthlessPresetVeryStrict95: FilterPreset = presetVeryStrict95;
